module.exports = __webpack_public_path__ + "static/media/buildingConstruction35.b86c6ce6.jpg";